import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { FormGroup } from "reactstrap";
import { RadioSelectField } from "../../CommonElements";
import { API_URL } from "../../Constant";

const TransportasiBerangkat = ({ control, watch, preview }) => {
  // Static options (hardcode)
  const staticOptionsKeberangkatan = [
    {
      id: 1,
      name: "09:25 WIB - Citilink (Bagasi 15kg)",
      value: "09:25 WIB - Citilink (Bagasi 15kg)",
    },
    {
      id: 2,
      name: "09:50 WIB - Batik Air (Bagasi 20kg)",
      value: "09:50 WIB - Batik Air (Bagasi 20kg)",
    },
  ];

  const optionsTransportasi = [
    {
      id: 1,
      name: "Berangkat sendiri",
      value: "Berangkat sendiri",
    },
    {
      id: 2,
      name: "Berangkat bersama dari Fasilkom Gedung Lama jam 06.00",
      value: "Berangkat bersama dari Fasilkom Gedung Lama jam 06.00",
    },
  ];

  // Ambil value maskapai_berangkat yang sedang dipilih user
  const selectedMaskapai = watch("maskapai_berangkat");

  // Filter opsi agar hanya menampilkan yang dipilih user, atau tampilkan semua jika belum ada pilihan
  const optionsKeberangkatan = selectedMaskapai
    ? staticOptionsKeberangkatan.filter(
        (opt) => opt.value === selectedMaskapai
      )
    : staticOptionsKeberangkatan;

  return (
    <div>
      <div className="purple-header mb-4 bg-primary">
        <h3 className="text-white p-3">Transportasi Berangkat</h3>
      </div>

      <div className="form-section-content">
        <FormGroup
          style={{
            border: "1px solid #ccc",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <Controller
            name="maskapai_berangkat"
            control={control}
            rules={{ required: "Harap pilih maskapai penerbangan" }}
            render={({ field, fieldState }) => (
              <RadioSelectField
                label="Pilihan Waktu Berangkat: Kamis, 26 Juni 2025"
                fieldState={fieldState}
                options={optionsKeberangkatan}
                {...field}
                isRequired
                disabled={true}
              />
            )}
          />
        </FormGroup>

        <FormGroup
          className="mt-4"
          style={{
            border: "1px solid #ccc",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <Controller
            name="transportasi_berangkat"
            control={control}
            rules={{ required: "Harap pilih transportasi ke bandara" }}
            render={({ field, fieldState }) => (
              <RadioSelectField
                label="Transportasi: Berangkat dari Fasilkom ke Bandara (Mengingat perjalanan dan kondisi lalu lintas, dimohon tepat waktu)"
                fieldState={fieldState}
                options={optionsTransportasi}
                {...field}
                isRequired
                disabled={true}
              />
            )}
          />
        </FormGroup>
      </div>
    </div>
  );
};

export default TransportasiBerangkat;